import { InspectionTranslationKeys } from 'intl/keys';
import { TranslationKey } from 'intl/types/translationKey';
import { ComplianceAnswerOption } from 'shared/domain/compliance/complianceAnswerOption';

const PROTOCOL_ITEM_RESULT_LABEL_KEYS: Record<
  ComplianceAnswerOption,
  TranslationKey
> = {
  [ComplianceAnswerOption.unset]: InspectionTranslationKeys.itemResultUnset,
  [ComplianceAnswerOption.notApplicable]:
    InspectionTranslationKeys.itemResultNotApplicable,
  [ComplianceAnswerOption.notPassed]: InspectionTranslationKeys.itemResultNotPassed,
  [ComplianceAnswerOption.passed]: InspectionTranslationKeys.itemResultPassed,
};

export function protocolItemResultLabelKey(
  status: ComplianceAnswerOption
): TranslationKey {
  return PROTOCOL_ITEM_RESULT_LABEL_KEYS[status];
}
